// this loads before (and needs to) iframe-lightbox.js as gulpfile takes files alphabetically from directory, could use seperate file, eg. _before-custom.js
(function () {
    var regEx = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
    var youtubePosts = document.querySelectorAll("[data-youtube-url]");
    youtubePosts.forEach(a => {
        var youtubeId = a.getAttribute("data-youtube-url").match(regEx)[1];
        var embeddLink = `https://www.youtube.com/embed/${youtubeId}?feature=oembed`;
        var imgSrc = `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
        a.setAttribute("href", embeddLink);
        a.querySelector("img").setAttribute("src", imgSrc);
    });
})();